import React, { Component } from 'react';
import PropTypes from 'prop-types';

class CoreLicenseDropdown extends Component {
	constructor(props) {
		super(props);
		this.assignedCoreLicenses = props.assignedCoreLicenses;
		this.localizedKeys = props.localizedKeys;
		this.locale = props.locale;
		this.currency = props.currency;
		this.state = {
			chevron: 'chevronDown',
		};
	}

	changeChevron = () => {
		let currentChevron = this.state.chevron;
		let newChevron = currentChevron === 'chevronDown' ? 'chevronUp' : 'chevronDown';
		this.setState({
			chevron: newChevron,
		});
	};

	renderAssignedCoreLicenses = () => {
		if (this.state.chevron === 'chevronDown') {
			return;
		} else {
			const listCoreLicenses = this.assignedCoreLicenses.map((license, index) => {
				return (
					<div key={index} className="coreLicenseDropdown-item listitems incart leader-2">
						<div className="config-item-name">
							<div className="trailer-0 phone-trailer-half">{license.productName}</div>
							<div className="trailer-0 font-size--1">
								{license.subscriptionId && (
									<div className="inlineElement subid">
										<span className="esri-font-demi">
											{this.localizedKeys.subscriptionIdLabel}
											{': '}
										</span>
										{license.subscriptionId}
									</div>
								)}
								<div className="inlineElement">
									<span className="esri-font-demi">
										{this.localizedKeys.expireLabel}
										{': '}
									</span>
									{this.props.formatStoreDate(license.dates[0].endDate, this.locale)}
								</div>
							</div>
						</div>
						<div className="config-item-assigned" data-pseudo-content={`${this.localizedKeys.licensesAssignedLabel}`}>
							<span className="esri-font-demi">
								{this.localizedKeys.licensesAssignedLabel}
								{': '}
							</span>
							{license.assignedQty}
						</div>
						<div className="config-item-subtotal incart" data-pseudo-content={`${this.localizedKeys.subTotalLabel}`}>
							<span className="esri-font-demi">
								{this.localizedKeys.subTotalLabel}
								{': '}
							</span>
							{this.props.formatStorePrice(license.dates[0].price * license.assignedQty, this.locale, this.currency)}
						</div>
					</div>
				);
			});

			return <div>{listCoreLicenses}</div>;
		}
	};

	render() {
		return (
			<div className="coreLicenseDropdown">
				<calcite-button
					appearance="transparent"
					color="blue"
					kind="brand"
					scale="m"
					href=""
					icon-end={this.state.chevron}
					alignment="center"
					width="auto"
					calcite-hydrated=""
					onClick={() => {
						this.changeChevron();
					}}>
					Core License Assignments
				</calcite-button>

				<div>{this.renderAssignedCoreLicenses()}</div>
			</div>
		);
	}
}

CoreLicenseDropdown.propTypes = {
	assignedCoreLicenses: PropTypes.array,
	localizedKeys: PropTypes.object,
	locale: PropTypes.string,
	currency: PropTypes.string,
	formatStoreDate: PropTypes.func,
	formatStorePrice: PropTypes.func,
};

export default CoreLicenseDropdown;
